import React, { memo } from 'react';
import styles from './informationCard.module.scss';
import SVG from 'react-inlinesvg';
import Divider from '../Divider';

const InformationCard = ({
    icon,
    title,
    options = [],
    loading = false,
    flex = "f100",
    flexOptions = "f33",
    flexDirectionOption = "row",
    row = false,
    customSkeleton = '',
    ...props
}) =>
    <div className={`${styles.container} ${styles[flex]}`} {...props}>

        <Divider >{title} </Divider>

        <div className={`${styles.body} ${row && styles.row}`}>
            {
                !loading && options.map(option =>
                    <div
                        key={`${option.label}-${option.value}`}
                        className={`
                            ${styles.item}
                            ${styles[flexOptions]}
                            ${flexDirectionOption === "row" ? "" : styles.itemColumn}
                        `}
                    >
                        {
                            typeof option.icon !== "undefined" &&
                            <SVG src={option.icon} className={styles[option.iconClass]} />
                        }
                        <span className={styles.label}>{option.label}</span>
                        <span className={styles.value}>{option.value}</span>
                    </div>
                )
            }
            {
                loading && customSkeleton
            }
        </div>
    </div>

export default memo(InformationCard);
